import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header"]
  static values = {
    activeClass: { type: String, default: "bg" }
  }

  connect() {
    const menuOverlay = document.getElementById('menu-overlay')
    const menuOpen = document.getElementById('menu-open')
    const menuClose = document.getElementById('menu-close')

    menuOpen?.addEventListener('click', () => {
      menuOverlay.classList.add('active')
      document.body.style.overflow = 'hidden'
    })

    menuClose?.addEventListener('click', () => {
      menuOverlay.classList.remove('active')
      document.body.style.overflow = ''
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menuOverlay.classList.contains('active')) {
        menuOverlay.classList.remove('active')
        document.body.style.overflow = ''
      }
    })

    if(document.getElementById("kv-video")){
      this.onScroll = this.onScroll.bind(this)
      window.addEventListener("scroll", this.onScroll)
      window.addEventListener("resize", this.onScroll)
      this.onScroll()
    }
  } // end connect

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
  }

  onScroll() {
    const triggerPoint = window.innerHeight
    this.headerTarget.classList.toggle(
      this.activeClassValue,
      window.scrollY >= triggerPoint
    )
  }
}
